import { Injectable } from '@angular/core';
import { StudyReportUnificationService } from './study-report-unification.service';
import { AuthService } from '../auth.service';
import { StudyReportSearchItem } from '../../model/study-report-search-item';
import { MatDialog } from '@angular/material';
import { StudyReportUnificationDialogComponent, StudyReportSearchItemUnificationDialogResponse } from '../../components/dialogs/study-report-unification-dialog/study-report-unification-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class StudyReportUnificationDialogService {

  constructor( private studyReportUnificationService: StudyReportUnificationService,
               public dialog: MatDialog,
               private authService: AuthService ) {
  }

  public async startUnificationDialogIfRequired(studyReportSearchItem: StudyReportSearchItem):
      Promise<StudyReportSearchItem> {
    return new Promise<StudyReportSearchItem>(async (resolve, reject) => {
      try {
        const candidates = await this.studyReportUnificationService
        .getStudyReportUnificationCandidates(+this.authService.getPhysicianId(),
          studyReportSearchItem.StudyReportId);
        if (candidates.length > 0) {
          this.startUnificationDialog(candidates, studyReportSearchItem, resolve, reject);
        } else {
          resolve(studyReportSearchItem);
        }
      } catch ( err ) {
        reject(err);
      }
    });
  }

  private startUnificationDialog(candidates: StudyReportSearchItem[],
    studyReportSearchItem: StudyReportSearchItem, resolve: any, reject: any) {

    const dialogRef = this.dialog.open(StudyReportUnificationDialogComponent, {
      width: '80%',
      maxHeight: '500px',
      data: {
      studyReportSearchItem: studyReportSearchItem,
        studyReportSearchItemUnificationCandidates: candidates
      }
    });

    dialogRef.afterClosed().subscribe(async (result: StudyReportSearchItemUnificationDialogResponse) => {
      if ( !result ) {
        resolve(result);
      } else {
        try {
          if ( result.studyReportChildsId ) {
            await this.studyReportUnificationService
            .createStudyReportUnification(result.studyReportSearchItem.StudyReportId,
              result.studyReportChildsId);
          }
          resolve(result.studyReportSearchItem);
        } catch ( err ) {
          reject(err);
        }
      }
    });
  }
}
